<template>
  <div class="about">
    <div class="section-background">
      <div class="container">
        <div class="hero">
          <div class="text">
            <h1 class="title">
              Software license Agreement
            </h1>
          </div>

          <h2>LUDIMOS B.V.</h2>
          <p>
            These General Terms and Conditions are binding, therefore please
            read this document carefully before accessing or using our website.
            If you do not agree to all the terms and conditions of this
            agreement, then you may not access the website or use any services.
            If these General Terms are considered an offer, acceptance is
            expressly limited to these General Terms and Conditions.
          </p>
          <p>
            Any new features or tools which are added to the Products shall also
            be subject to the General Terms and Conditions.
          </p>

          <b>1. LUDIMOS General provisions</b>
          <p>
            1.1 The website, located at
            <a href="https://ludimos.com">www.ludimos.com</a> and incorporating
            our web app <span>(Website) </span>
            <a href="https://app.ludimos.com">app.ludimos.com</a>, and the
            associated application known as Ludimos App, (Application), are
            owned and operated by LUDIMOS B.V., with seat In de Wolken 226,
            1186EP Amstelveen, The Netherlands.
          </p>

          <p>
            1.2 In these Terms of Use, any reference to "we" or "us" is a
            reference to LUDIMOS B.V.
          </p>

          <b>2. Accepting the Terms</b>
          <p>
            2.1 In order to use our Website and App, you must first agree to
            these Terms. You may not use our Website and/or App if you do not
            accept the Terms. You can accept the Terms by:
          </p>
          <p>
            2.1.1 clicking to accept or agree to the Terms and Conditions, where
            this option is made available to you by us; or
          </p>
          <p>
            2.1.2 by actually using our Website and/or App, whether on a trial
            or subscribed basis. In this case, you understand and agree that we
            will treat your use of the Website or App as acceptance of the Terms
            and Conditions from that point onwards.
          </p>
          <p>
            2.2 We may update or change these Terms and Conditions from time to
            time and recommend that you review the Terms on a regular basis.
          </p>

          <b>3. User license and Permitted Users</b>
          <p>
            3.1 In consideration for the payment of the Subscription Fee, we
            hereby grant you a non-exclusive, non-assignable, non-transferable,
            non-sublicensable license to utilise the Website and/or App for the
            purposes of carrying out (or enabling third parties in teams,
            associated with your User Account(s) to carry out) a performance
            analysis;
          </p>
          <p>
            3.2 You may only use our Services (in the following the
            “Subscription Services”), in accordance with any specifications
            agreed in writing with us when you purchase a subscription.
          </p>
          <p>
            3.3 You may allow third parties (coaches or players/athletes, in the
            following “third- party users”), to access the Subscription Services
            through your User Account(s) subject to the following provisions:
          </p>
          <p>
            a) any such use shall be solely and strictly for the purposes of
            carrying out performance analysis of the relevant team and
            players/athletes;
          </p>
          <p>
            b) you shall be responsible for any acts and/or omissions of any
            such third party users which, if carried out by you would amount to
            a breach of this Agreement;
          </p>
          <p>
            c) the number of third party users shall be limited to the maximum
            number of users agreed between you and LUDIMOS at the time of
            purchase of the license; and
          </p>
          <p>
            d) you acknowledge and agree that LUDIMOS reserves the right to
            block the access of a third- party user at any and all times if a
            breach of these Terms and Conditions is feared.
          </p>

          <b>4. Subscription and Account</b>
          <p>
            4.1 In order to use our Subscription Services you will be required
            to set up a user account. In order to do this, you will need to
            provide LUDIMOS with some information about you, as well as details
            about your sports club (in the following: “Account Details”).
          </p>
          <p>
            4.2 You hereby represent and warrant to us that any and all Account
            Details provided by you are true, accurate and complete; and you do
            possess all necessary consents and/or authority to provide us with
            the Account Details for use by us in accordance with this Agreement.
          </p>
          <p>
            4.3 Moreover, you undertake to notify LUDIMOS without any delay of
            any changes to any Account Details and guarantee not to impersonate
            any other person or entity or to use a false name or a name that you
            are not authorised to use.
          </p>
          <p>
            4.4 You also agree and understand that you are responsible for
            maintaining the confidentiality of passwords associated with your
            User Account. Accordingly, you agree that you will be solely
            responsible to us for all activities that occur under your account,
            as determined, noted, or recorded by us.
          </p>
          <p>
            4.5 You grant LUDIMOS the right to access your User Account for the
            purposes of any service improvement or upgrade.
          </p>

          <b> 5. User Content</b>
          <p>
            5.1 You agree that you are solely responsible for any media files,
            metadata, graphics, photo’s, videos and other like materials that
            created, uploaded, downloaded, transmitted, stored, posted, emailed
            or published (whether by you or any third party user) while using
            the Subscription Services and for the consequences of your and/or
            any third party user’s actions.
          </p>

          <p>
            5.2 You hereby grant LUDIMOS an irrevocable non-exclusive, royalty
            free, sub-licensable license to use the User Content as required for
            the provision of our Services and to collect and retain aggregate
            usage data for our own business purposes, (provided such aggregate
            data does not include Personal Data).
          </p>
          <p>
            5.3 With regard to the uploading of any and all User Content you
            represent and warrant that you have the lawful right to reproduce
            and distribute such User Content; you have the rights, power and
            authority to grant the license at clause 5.2;
          </p>
          <p>
            5.4 The uploading, downloading, posting, emailing or transmission by
            any other means of the User Content will not constitute or encourage
            a criminal offence, violate the rights of any party or otherwise,
            create liability or violate any local, state, national or
            international law;
          </p>
          <p>
            5.5 LUDIMOS does not control the User Content in the Subscription
            Services nor does guarantee the accuracy, integrity or quality of
            such User Content. You acknowledge and agree that we are not
            responsible or liable in any way for any User Content provided by
            you or other users and have no duty to moderate such User Content.
            However, we reserve the right at all times to determine whether User
            Content is appropriate and in compliance with these Terms and
            Conditions, and may move, modify and/or remove User Content at any
            time, without prior notice and in our sole discretion, if such User
            Content is found to be in non-compliance with these General Terms.
          </p>
          <p>
            5.6 You shall indemnify us and hold us harmless, without limitation
            and upon demand, against any claims, proceedings, actions, costs,
            damages, expenses, liability, losses and demands (including
            reasonable legal expenses) that may be incurred by us and whether
            directly or indirectly arising from: (a) any User Content submitted,
            posted, transmitted, or otherwise made available by you or a third
            party-user and/or any breach by you of these Terms and Conditions.
            Also, (b) you shall indemnify us and hold us harmless against any
            infringement of any third party intellectual property rights arising
            in connection with any User Content added or used by you or a third
            party-user.
          </p>

          <b>6. Acceptable Use Policy</b>
          <p>
            6.1 The Subscription Services may only be used strictly and solely
            for the purposes of enabling coaches of team sports and individual
            players in a team to carry out performance analysis of sport games,
            activities and performances and may not be used for any other
            purposes whatsoever without our prior, written and informed consent
            being obtained.
          </p>
          <p>
            6.2 You agree that you will not (nor permit, authorise or enable any
            other person to): (a) take any action that imposes, or may impose an
            unreasonable or disproportionately large load on our infrastructure;
            (b) copy, duplicate, reproduce, rent, lease, operate a service
            bureau, transfer, redistribute, sub-license, loan, sell, trade,
            resell, modify, create derivative works, distribute or publicly
            display, all or any part of our App or Website without our prior
            written consent; (c) interfere or attempt to interfere with the
            proper working of the Website and App; (d) bypass any measures we
            may use to prevent or restrict access to the Website and App; (e)
            attempt to reverse engineer, decompile or otherwise seek to obtain
            access to the source code; (f) engage in any other activity that
            interferes with or disrupts the Website and App.
          </p>
          <p>
            6.3 You shall not upload (nor permit, authorise or enable any other
            person to upload) any content which: (a) is misleading, harmful,
            threatening, abusive, harassing, defamatory, offensive, violent,
            obscene, pornographic, vulgar, libellous, racially, ethnically,
            religiously or otherwise objectionable; (b) constitutes unauthorised
            disclosure of personal or confidential information; (c) violates the
            rights of any party (including but not limited to any patent,
            trademark, trade secret, publicity right, privacy right, copyright
            or other intellectual property right) or otherwise create liability
            or violate any local, state, national or international law; (d)
            contains viruses, trojans, worms, corrupted files or code, files and
            programs designed to impede or destroy the functionality of any
            computer software or hardware; spyware and malware designed for
            phishing and with a view to compromise the data security and
            integrity, and obtain sensitive personal or financial information;
            and/or (e) constitutes or encourages a criminal offence.
          </p>

          <b>7. Intellectual Property</b>
          <p>
            7.1 You acknowledge and recognise that we (and/or our licensors) own
            all legal rights, title and interest in and to our Website and App,
            as well as any intellectual property rights concerning and connected
            to the Services (including source code), all reports, data, records,
            statistics, graphs, databases or like material generated from any
            analysis conducted using our Website and App, in each case, whether
            those rights happen to be registered or not, and wherever in the
            world those rights may exist.
          </p>
          <p>
            7.2 Nothing in this Agreement shall confer on you any right, title
            or interest in any (part of) our Website and App or any derivative
            work, (except the rights of use set out in this Agreement). You
            further acknowledge that our Services may contain information which
            is designated confidential by and that you shall not disclose such
            information without our prior written consent.
          </p>
          <p>
            7.3 Unless you have agreed otherwise in writing with us, nothing in
            these Terms and Conditions provides you a right to use any of our
            trade names, trademarks, service marks, logos, domain names and
            other distinctive brand features without our express written
            permission.
          </p>
          <p>
            7.4 You may not copy or make any use of any part of our Website and
            App for any purposes save as expressly provided in this Agreement.
            In particular, you may not modify, rent, lease, loan, sell,
            distribute or create derivative works based on our App or Website,
            (either in whole or in part).
          </p>
          <p>
            7.5 In the event that your use of the Services, if used in
            accordance with this Agreement, infringes any intellectual property
            rights of a third party, we may, at our sole discretion and expense,
            replace or modify the that part of our Services so that it is no
            longer infringing or obtain for you the right to continue using our
            Services.
          </p>

          <b>8. Privacy</b>
          <p>
            8.1 You acknowledge that information about you, including
            information provided upon becoming a Registered User and creating an
            Account will be collected, held and used by us in accordance with
            our
            <router-link to="/privay-policy">
              Privacy Policy.
            </router-link>
          </p>

          <b>9. Fees</b>
          <p>
            9.1 Access to the Subscription Services is on a subscription basis,
            except where you are availing of any trial period granted by us. We
            will charge you an annual subscription fee for access to the
            Service.
          </p>
          <p>
            9.2 If a failure in the payment made by you takes place we reserve
            the right to suspend or lock access to your User Account (and those
            linked accounts of any third party-user), until payment is received
            or to terminate this Agreement and delete your User Content in
            accordance. Moreover, we reserve the right to charge interest on the
            overdue amount at the rate of 10%. Such interest shall accrue on a
            daily basis from the due date until actual payment of the overdue
            amount, whether before or after judgment.
          </p>
          <p>
            9.2 We reserve the right to change the price of the Subscription Fee
            or institute new changes or fees provided we give you advance notice
            of the same. Price changes and institution of new charges
            implemented during your subscription term will apply to subsequent
            subscription terms
          </p>

          <b>10. Term and Termination</b>

          <p>
            10.1 This Agreement will commence on the date on which we start
            providing our Services to you and shall continue for a period of 12
            months thereafter (Subscription Term). Either party may terminate
            this Agreement by giving the other no less than 30 days’ written
            notice, to expire no earlier than the end of the Subscription Term
            (or any subsequent 12 (twelve) month period. If no such notice is
            given, the Agreement shall continue for further periods of 12 months
            on the same terms.
          </p>
          <p>
            10.2 We reserve the right to decline any application from you to
            register as a user of the Service in our sole discretion and/or to
            suspend your use of the Service where we in our sole discretion
            believe that you are in breach of any provision of these Terms and
            Conditions.
          </p>
          <p>
            10.3 Without prejudice to any other rights or remedies to which we
            might be entitled, we may at any time, terminate this Agreement with
            immediate effect and without liability to you in the following
            cases:
          </p>
          <p>
            - you have materially breached any provision of the Terms and
            Conditions,
          </p>
          <p>- we are required to do so by law; or</p>
          <p>
            - you cease to trade; or become insolvent or unable to pay your
            debts within the meaning of the insolvency legislation applicable to
            you; or
          </p>
          <p>
            - a third person is appointed to manage or take control of the whole
            part of your business or assets, or notice of an intention to
            appoint such a person is given or documents relating to such an
            appointment are filed with any court; or
          </p>
          <p>
            - any process is instituted which could lead to you being dissolved
            and your assets being distributed to your creditors, shareholders or
            other contributors. In all these cases these Terms and Condition and
            the Agreement with you comes to an end and the license granted at
            clause 3.1 terminates;
          </p>

          <b>11. Limitation of Liability</b>
          <p>
            11.1 Nothing in these Terms and Condition, including this clause,
            shall exclude or limit any warranty or liability which may not be
            lawfully excluded or limited by applicable law, including liability
            for fraud or for death or personal injury caused by our negligence.
          </p>
          <p>
            11.2 You expressly understand and so agree that your use of the
            Service is at your sole risk and that the Service is provided "as
            is" and "as available."
          </p>
          <p>
            11.3 In particular, we, our subsidiaries and affiliates, and our
            licensors, do not represent or warrant to you that: - your use of
            the Service will meet your requirements, that your use of the
            Service will be uninterrupted, timely, secure or free from error or
            that defects in the operation or functionality of the Service
            provided to you will be corrected; - any information obtained by you
            as a result of your use of the Service will be accurate or reliable.
          </p>
          <p>
            11.4 Any material downloaded or otherwise obtained or accessed
            through the use of the Service is performed at your own discretion
            and risk. You fully understand and agree that will be solely
            responsible for any damage, loss, or prejudice to your computer
            system or other device or loss of data that results from the
            download or access of any such material.
          </p>
          <p>
            11.5 No advice or information, whether oral or written, obtained by
            you from us or any of our subsidiaries, affiliates, agents,
            employees, or personnel, or through or from the Service shall create
            any warranty not expressly stated in these Terms and Conditions.
          </p>
          <p>
            11.6 You expressly understand and agree that we and our licensors
            shall not be liable to you for any direct, indirect, special,
            incidental or consequential loss or damage which may arise in
            respect of the Service and/or its use or non-availability; loss of
            profit, business revenue, goodwill and anticipated savings: any
            trading or other losses which you may incur as a result of use of or
            reliance upon any content; the deletion of, corruption of, or
            failure to store, any content and other communications data
            maintained or transmitted by or through your use of the Service; or
            any effect which use of the Service may have on any software you
            use.
          </p>

          <p>
            11.7 Subject to the clauses above, the aggregate liability of us in
            respect of any loss or damage suffered by you and arising out of or
            in connection with the use of the Service by you and/or any third
            party shall not exceed the amount of the total fees actually paid by
            you to us in the twelve months preceding the date of your claim.
          </p>

          <b>12. General</b>
          <p>
            12.1 You shall not assign, transfer or sub-license any of your
            rights or obligations under these Terms and Conditions. We may at
            any time assign all or any of our rights and transfer all or any of
            our obligations under these Terms.
          </p>
          <p>
            12.3 If any part of any provision of these Terms and Conditions
            shall be or become invalid, unlawful or unenforceable to any extent,
            then the remainder of such provision and all other provisions shall
            continue to be valid and enforceable to the fullest extent permitted
            by law.
          </p>
          <p>
            12.4 These Terms and Conditions represent the entire agreement of
            you and us in relation to the subject matter of these Terms and
            supersedes any previous agreement between you and us in relation to
            the Service.
          </p>

          <b>13. Law and Jurisdiction</b>
          <p>
            13.1 These Terms and Conditions shall be construed in accordance
            with the law of the Netherlands and the parties hereby submit to the
            exclusive jurisdiction of the District Court of Amsterdam any
            disputes which may arise in connection with these Terms and
            Conditions.
          </p>

          <p>Last revised on June 3, 2020.</p>

          <div class="visual">
            <div class="background">
              <img
                src="../assets/img/hero-background.svg"
                alt="background visual"
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "SoftwarelicenseAgreement",
  metaInfo() {
    return {
      title: this.textEllipsis(`Software license Agreement`, 25),
    };
  },
};
</script>
